import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";
import MobileDatePicker from "commons/ui/input/MobileDatePicker";
import SwitchInput from "commons/ui/input/SwitchInput";
import WysiwygSimpleEditor from "commons/ui/input/WysiwygSimpleEditor";
import Paper from "commons/ui/Paper";

import TwoLanguagesAdornment from "components/subComponents/TwoLanguagesAdornment";

import { CmNewsFormHook } from "hooks/form/useCmNewsForm";

type PropsType = {
    formNewsHook: CmNewsFormHook;
};

function CmNewsForm({ formNewsHook }: Readonly<PropsType>) {
    const { datePickerHookFrom, datePickerHookTo, formHook } = formNewsHook;

    const { checkErrorVisibility, setValue, form } = formHook;

    return (
        <GridColumn>
            <Paper>
                <GridColumn>
                    <GridRow className={"title-margin"}>
                        <GridItem>
                            <h2>Impostazioni</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-12"}>
                            <SwitchInput
                                checked={form.enabled}
                                label={"Visibile"}
                                setValue={setValue}
                                path={"enabled"}
                                alignedToForm
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-6-12"}>
                            <MobileDatePicker datePickerHook={datePickerHookFrom} />
                        </GridItem>
                        <GridItem className={"col-xs-6-12"}>
                            <MobileDatePicker datePickerHook={datePickerHookTo} />
                        </GridItem>
                    </GridRow>

                    <GridRow className={"title-margin"}>
                        <GridItem>
                            <h2>Testo Italiano</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-12"}>
                            <InputText
                                label={"Titolo"}
                                startAdornment={TwoLanguagesAdornment("it")}
                                value={form.text.it.title}
                                setValue={setValue}
                                path={"text.it.title"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-12"}>
                            <WysiwygSimpleEditor
                                label={"Descrizione"}
                                bigDefault={true}
                                value={form.text.it.description}
                                path={"text.it.description"}
                                setValue={setValue}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>

                    {/* Testo Inglese — hidden
                    <GridRow className={"title-margin"}>
                        <GridItem>
                            <h2>Testo Inglese</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-12"}>
                            <InputText
                                label={"Titolo"}
                                startAdornment={TwoLanguagesAdornment("en")}
                                value={form.text.en.title}
                                setValue={setValue}
                                path={"text.en.title"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-12"}>
                            <WysiwygSimpleEditor
                                label={"Descrizione"}

                                value={form.text.en.description}
                                path={"text.en.description"}
                                setValue={setValue}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>
                    */}
                </GridColumn>
            </Paper>
        </GridColumn>
    );
}

export default CmNewsForm;
